module.exports = __webpack_public_path__ + "static/media/carta_59.04d008c5.jpg";